import { z } from 'zod'

import { blockOf, mediaIdSchema, mediaSchema } from './common'
import { BlockType } from './types'

export const speakerBlockSchema = z.object({
    ...blockOf(BlockType.SPEAKER),
    photoMediaId: mediaIdSchema,
    photoMedia: mediaSchema,
    name: z.string(),
    role: z.string(),
})

export type SpeakerBlockData = z.infer<typeof speakerBlockSchema>
